import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { PrimitiveAtom, useAtomValue } from "jotai";
import { Flex, Scroller } from "src/elements";
import { UnrangedContainer } from "./UnrangedContainer";
import { usePogAtomActions } from "src/components/Planogram/store/actions";

interface Props {
  pogAtom: PrimitiveAtom<Pog>;
}

export const UnrangedContainers = ({ pogAtom }: Props) => {
  const pog = useAtomValue(pogAtom);
  const { restoreContainer } = usePogAtomActions(pogAtom);

  return (
    <Scroller>
      <Flex width="100%" column gap="10px" padding="10px">
        {pog.unrangedContainers.map((container, i) => (
          <UnrangedContainer key={i} container={container} restoreContainer={restoreContainer} />
        ))}
      </Flex>
    </Scroller>
  );
};
